import createEngine, {
  DagreEngine,
  DiagramModel,
} from "@projectstorm/react-diagrams";
import * as React from "react";
import AdvancedBuilder from "./AdvancedBuilder";
import { DeleteItemsAction } from "@projectstorm/react-canvas-core";
import LogicNodeFactory from "./nodes/Logic/LogicNodeFactory";
import CustomLinkFactory from "./links/CustomLinkFactory";
import CustomPortFactory from "./ports/CustomPort/CustomPortFactory";

export default function ProjectBuilder() {
  // 1) setup the diagram engine
  const engine = createEngine({ registerDefaultDeleteItemsAction: false });

  // disable dangling links
  engine
    .getStateMachine()
    .getCurrentState().dragNewLink.config.allowLooseLinks = false;

  // use shift-delete to remove nodes instead of delete
  engine.getActionEventBus().registerAction(
    new DeleteItemsAction({
      keyCodes: [46],
      modifiers: {
        shiftKey: true,
      },
    })
  );

  // register all the custom factories
  engine.getNodeFactories().registerFactory(new LogicNodeFactory());
  engine.getLinkFactories().registerFactory(new CustomLinkFactory());
  engine.getPortFactories().registerFactory(new CustomPortFactory());

  const dagreEngine = new DagreEngine({
    graph: {
      rankdir: "LR",
      // ranker: "longest-path",
      marginx: 40,
      marginy: 40,
      ranksep: 200,
    },
    includeLinks: true,
  });

  // 2) setup the diagram model
  const model = new DiagramModel();

  // 5) load model into engine
  engine.setModel(model);

  // 6) render the diagram!

  return <AdvancedBuilder engine={engine} dagreEngine={dagreEngine} />;
}
